<template lang="pug">
    .list
        .list__content(v-if="user.isSuperadmin || user.isManagerOrSupport || user.type === 'teacher' || user.type ==='admin'")
            cs-loader(v-if="isLoading")
            div(v-else)
                .box
                    .form-container__header
                        .form-container__title(v-text='homeworkTemplateEditorHeader')
                    form(@submit.prevent='sendForm')
                        .form-container__fields
                            .row
                                .form-container__column
                                    label.form-container__label
                                        | {{ $i18n.t('templates.template_form_name') }}
                                    .form-container__select
                                        div
                                            cs-input(
                                                v-model="form.name",
                                                v-validate="'required'",
                                                :data-vv-as="$i18n.t('templates.template_form_name')",
                                                name="templateName",
                                                :error="errors.has('templateName')"
                                            )
                                        help-text(error, slot="help-text", v-if="errors.has('templateName')") {{ errors.first('templateName') }}
                            .row(v-if="user.pointsAccesses.length > 1")
                                .form-container__column
                                    label.form-container__label {{ $i18n.t('templates.template_form_coursesTypes') }}
                                    .form-container__select
                                        div
                                            cs-multiselect(
                                                v-model="selectedCourseType"
                                                :options="coursesTypes"
                                                :allow-empty="false"
                                                :multiple="false"
                                                track-by="mode"
                                                label="label"
                                                v-validate="'required'"
                                                data-vv-value-path="innerValue",
                                                data-vv-name="coursesTypes",
                                                :disabled="!!id"
                                                :placeholder="$i18n.t('templates.template_form_selectCoursesTypes')"
                                                @select="handleCourseTypeSelect($event.mode)"
                                            )
                            .row
                                .form-container__column
                                    label.form-container__label {{ $i18n.t('templates.template_form_courses') }}
                                    .form-container__select
                                        div
                                            cs-multiselect(
                                                v-model="form.courses",
                                                :options="courses",
                                                track-by="id",
                                                :searchable="true",
                                                :loading="loadingCourses",
                                                :placeholder="$i18n.t('templates.template_form_coursesPlaceholder')",
                                                label="name",
                                                @open="getCourses",
                                                v-validate="'required'",
                                                data-vv-value-path="innerValue",
                                                data-vv-name="courses",
                                                :data-vv-as="$i18n.t('templates.template_form_courses').toLowerCase()",
                                                :error="errors.has('courses')"
                                                :disabled="user && !user.pointsAccesses.length"
                                            )
                                        help-text(error, slot="help-text", v-if="errors.has('courses')") {{ errors.first('courses') }}
                            .row(v-if="form.courses.length && !form.relation.visibleOnlyToMe")
                                .form-container__column
                                    label.form-container__label {{ $i18n.t('trainer.trainer_gameFormSetting_accessSettings') }}
                                    .form-container__select
                                        div
                                            cs-multiselect(
                                                v-model="form.relation.relationName"
                                                :options="relationsTypes"
                                                :allow-empty="true"
                                                :multiple="false"
                                                :custom-label="getRelationName",
                                                data-vv-value-path="innerValue",
                                                data-vv-name="relations",
                                                :placeholder="$i18n.t('trainer.trainer_textsRelationSelector')"
                                            )
                                            .form__field
                                                label.form__label
                                                .form__field-body
                                                    help-text(slot='help-text', v-text=" $i18n.t('billing.billing_stocks_schoolsHelper')")
                            .row(v-if="form.relation.relationName")
                                .form-container__column
                                    label.form-container__label {{ $i18n.t('templates.template_form_' + relationTypeName) }}
                                    .form-container__select
                                        div
                                            cs-multiselect(
                                                v-model="form.relation.chosenRelationItems"
                                                :options="relationItems"
                                                :allow-empty="true"
                                                :multiple="true"
                                                track-by="id"
                                                label="name"
                                                :loading="loadingRelationItems"
                                                data-vv-name="chosenRelationItems",
                                                :placeholder="$i18n.t('trainer.trainer_textsRelationSelector')"
                                                @open="getRelationItems"
                                            )
                            .row
                                .form-container__column
                                    label.form-container__label {{ $i18n.t('presentations.presentations_form_visibleOnlyToMe') }}
                                    .form-container__select
                                        div
                                            cs-checkbox(v-model="form.relation.visibleOnlyToMe")
                            .form-container__fields.games-fields(v-if="showTextsDaysField")
                                .row
                                    .form-container__column
                                        label.form-container__label {{ $i18n.t(multipleDaysInputLabel) }}
                                        .form-container__select
                                            div
                                                cs-multiselect(
                                                    v-model="form.chosenDaysAmount",
                                                    :options="daysForTexts",
                                                    :multiple="false",
                                                    :allow-empty="false",
                                                    :placeholder="placeholderForMultipleDaysSelect",
                                                    :disabled="!multipleDaysGameIsChosen"
                                                )
                                            help-text(error, slot="help-text", v-if="errors.has('games') || (form.courses.length && !games.length)")
                                                | {{ errors.first('games') || $i18n.t('errors.error_differentGamesInCourses') }}
                            .form-container__fields.games-fields(v-if='form.games')
                                div(v-for="index in form.games.length + 1", :key="index")
                                    .row
                                        .form-container__column
                                            label.form-container__label(v-text="$i18n.t('homework.homework_create_chooseGames')")
                                            .form-container__select
                                                div
                                                    cs-multiselect(
                                                        :options="games",
                                                        :multiple="false",
                                                        :allow-empty="false",
                                                        :placeholder="games.length ? $i18n.t('templates.template_form_gamesPlaceholder') : $i18n.t('fields.fields_selectCourseFirst')",
                                                        :disabled="!games.length",
                                                        label="name",
                                                        :value="form.games[index - 1]",
                                                        @select="gameHandler($event, index - 1)",
                                                        :error="errors.has('games')"
                                                    )
                                                help-text(error, slot="help-text", v-if="errors.has('games') || (form.courses.length && !games.length)")
                                                    | {{ errors.first('games') || $i18n.t('errors.error_differentGamesInCourses') }}
                        .form-container__fields
                            games-list(
                                :games="form.games",
                                @editGame="editGame",
                                @up="moveGame($event, 'up')",
                                @down="moveGame($event, 'down')",
                                @remove="removeGame"
                            )
                .form-container-footer
                    cs-button.form-container-footer__button(
                        color="blue",
                        pattern="primary-outline",
                        @click.prevent="$router.push({name: `${type}:list`, params: {type: type}})"
                    )
                        | {{ $i18n.t('common.common_button_cancel') }}
                    =" "
                    cs-button.form-container-footer__button.form-container-footer__button_submit(
                        color="blue",
                        @click="sendForm",
                        :disabled="isLoading || user && !user.pointsAccesses.length || !form.games.length"
                    )
                        cs-loader(v-if="isLoading")
                        span {{ $i18n.t('templates.template_form_publish') }}
        div.list__content(v-else)
            | {{ $i18n.t('errors.page_not_access') }}
</template>

<script>
    /*eslint-disable*/
    import CourseApi from '../../api/course';
    import TrainerUtilities from '../../utils/trainer/trainer';
    import _, { kebabCase } from 'lodash';
    import { getInitParameters } from '../../utils/trainer/getInitParameters';
    import GamesList from '../games/GamesList.vue';
    import { mapState } from 'vuex';
    import TemplateApi from '../../api/templates/template';
    import CsCheckbox from '../../elements/CsCheckbox';
    import SchoolApi from '../../api/school';
    import GradeApi from '../../api/grade';
    import HelpText from '../../elements/HelpText';
    import getBase64FromUrl from '../../utils/getBase64FromUrl';
    import TrainerGames from '../../config/trainer.json';
    import BonusGamesApi from '../../api/bonusGames/bonusGames';

    const GAMES_WITH_MULTIPLE_DATES = ['Texts', 'TextsOnline', 'Puzzle', 'PunctuationMarks', 'Orthograph'];

    const ARR_TITLE_PAGE = {
        'homework-template:create': 'templates.template_create_title',
        'homework-template:edit': 'templates.template_edit_title',
        'lesson-conducting-template:create': 'templates.template_create_lesson_conducting_title',
        'lesson-conducting-template:edit': 'templates.template_edit_lesson_conducting_title',
    };

    export default {
        props: {
            id: [Number, String],
            copy: {
                type: Object,
                default: null,
            },
            type: {
                type: String,
                required: true,
            },
        },
        mixins: [TrainerUtilities, getBase64FromUrl],
        mounted() {
            this.coursesTypes = this.coursesTypes.filter(type => this.user.pointsAccesses.includes(type.mode));
            this.fetchData();
            this.updateAvailableBonusGamesSlugSet();
        },
        beforeRouteEnter(to, from, next) {
            next(self => {
                if (from.params.coursesType && self.user.pointsAccesses.length > 1) {
                    self.form.coursesType = from.params.coursesType;
                }
            });
        },
        beforeRouteLeave(to, from, next) {
            let allowedPaths = ['game:edit', 'homework-template:create'];
            if (!allowedPaths.includes(to.name)) {
                this.$store.dispatch('setPuzzleGame', null);
                this.$store.dispatch('setGame', null);
                this.$store.dispatch('setParamsArray', null);
                this.$store.dispatch('setHomework', null);
                this.$store.dispatch('setHomeworkCopy', null);
                this.$store.dispatch('setGamesParameters', null);
                if (this.isSuccessfullyUpdated) {
                    to.params.isSuccessfullyUpdated = true;
                } else if (this.isSuccessfullyCreated) {
                    to.params.isSuccessfullyCreated = true;
                }
            }
            next();
        },
        data() {
            return {
                loadingCourses: false,
                loadingRelationItems: false,
                courses: [],
                form: {
                    name: '',
                    courses: [],
                    games: [],
                    coursesType: '',
                    type: '',
                    chosenDaysAmount: 1,
                    relation: {
                        chosenRelationItems: [],
                        relationItemsIds: [],
                        relationName: '',
                        visibleOnlyToMe: false,
                    },
                },

                relations: {
                    grade: this.$i18n.t('homework.homework_create_grade'),
                    school: this.$i18n.t('homework.homework_create_school'),
                },
                relationsTypes: ['grade', 'school'],
                relationItems: [],
                isLoading: false,
                coursesTypes: [
                    {
                        label: this.$i18n.t('common.common_course_mentalArithmetic'),
                        mode: 'mentalArithmetic',
                    },
                    {
                        label: this.$i18n.t('common.common_course_fastReading'),
                        mode: 'fastReading',
                    },
                    {
                        label: this.$i18n.t('common.common_course_onlineSchool'),
                        mode: 'onlineSchool',
                    },
                    {
                        label: this.$i18n.t('common.common_course_mathMagic'),
                        mode: 'mathMagic',
                    },
                    {
                        label: this.$i18n.t('common.common_course_memoryDevelopment'),
                        mode: 'memoryDevelopment',
                    },
                    {
                        label: this.$i18n.t('common.common_course_multiplication'),
                        mode: 'multiplication',
                    },
                    {
                        label: this.$i18n.t('common.common_course_readingEn'),
                        mode: 'readingEn',
                    },
                    {
                        label: this.$i18n.t('common.common_course_russianLanguage'),
                        mode: 'russianLanguage',
                    },
                ],
                selectedCourseType: null,
                courseTypeChanged: false,
                isSuccessfullyUpdated: false,
                isSuccessfullyCreated: false,
                daysForTexts: [1, 2, 3, 4, 5, 6, 7, 8],
                availableBonusGamesSlugSet: new Set(),
                oldBonusGamesSlugSet: new Set(),
            };
        },
        watch: {
            'form.relation.relationName': {
                handler(val, oldVal) {
                    if (val !== oldVal && oldVal !== '') {
                        this.relationItems = [];
                        this.getRelationItems();
                        this.form.relation.chosenRelationItems = [];
                    }
                },
                deep: true,
            },
            'form.relation.visibleOnlyToMe': {
                handler(val, oldVal) {
                    if (val !== oldVal && oldVal) {
                        this.form.relation.relationName = '';
                        this.form.relation.chosenRelationItems = [];
                    }
                },
                deep: true,
            },
            'form.chosenDaysAmount': {
                handler(val) {
                    this.syncTextsWithDays();
                    if (val === 1) {
                        this.form.games.forEach(game => {
                            if (GAMES_WITH_MULTIPLE_DATES.includes(game.slug)) {
                                Object.assign(game.parameters.default, game.parameters.default[0]);
                            }
                        });
                    }
                    this.form.games.forEach(game => {
                        if (game.slug === 'Texts' || game.slug === 'TextsOnline') {
                            !_.isArray(game.parameters.default)
                                ? (game.parameters.default.settings.days = val)
                                : game.parameters.default.map(defaultSetting => (defaultSetting.settings.days = val));
                        }
                    });
                },
            },
            homework: {
                handler(template) {
                    if (template) {
                        this.form = template;
                    }
                },
                immediate: true,
            },
            'form.games.length'(val) {
                if (val) {
                    this.errors.remove('games');
                }
            },
            'form.courses': {
                handler(courses) {
                    let coursesIds = courses.map(course => course.id);
                    this.form.games = this.form.games.filter(game => {
                        return coursesIds.includes(game.courseId) || (!game.courseId && courses.length);
                    });
                },
                deep: true,
            },
            'form.coursesType': 'updateAvailableBonusGamesSlugSet',
        },
        methods: {
            syncTextsWithDays() {
                this.form.games = this.form.games.map(game => {
                    if ((game.slug === 'Texts' || game.slug === 'TextsOnline') && _.isArray(game.parameters.default)) {
                        game.parameters.default = game.parameters.default.slice(0, this.form.chosenDaysAmount);
                    }
                    return game;
                });
                this.$store.dispatch('setHomework', this.form);
            },
            getRelationName(relation) {
                return this.relations[relation];
            },
            getRelationItems() {
                this.loadingRelationItems = true;
                let api = this.form.relation.relationName === 'school' ? SchoolApi : GradeApi;
                let params =
                    this.form.relation.relationName === 'school'
                        ? { all: true, withActiveAccount: true }
                        : {
                              schoolId: this.user.isSuperadmin ? null : this.user.school && this.user.school.id,
                              schoolsIds: this.user.isSuperadmin
                                  ? null
                                  : this.user.schools && this.user.schools.map(school => school.id),
                              coursesIds: this.form.courses && this.form.courses.map(course => course.id),
                              status: 'active',
                              all: true,
                          };
                api.list(params)
                    .then(data => {
                        let items = this.form.relation.relationName === 'school' ? data.schools : data.grades;
                        this.relationItems = [];
                        if (items) {
                            this.relationItems = _.uniqBy([...this.relationItems, ...items]);
                        }
                    })
                    .catch(() => {
                        this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                    })
                    .finally(() => (this.loadingRelationItems = false));
            },
            handleCourseTypeSelect(mode) {
                this.form.coursesType = mode;
                this.courseTypeChanged = true;
            },
            async assignImage(game) {
                if (_.isArray(game.parameters.default)) {
                    game.parameters.default.map(
                        async setting =>
                            (setting.image = await this.getBase64ImageFromUrl(
                                this.$options.filters.apiFile(setting.imageSrc)
                            )) /
                            user /
                            student
                    );
                } else {
                    game.parameters.default.image = await this.getBase64ImageFromUrl(
                        this.$options.filters.apiFile(game.parameters.default.imageSrc)
                    );
                }
            },
            fetchData() {
                if (this.id && !this.homework) {
                    this.isLoading = true;
                    TemplateApi.show(this.id).then(homeworkTemplate => {
                        homeworkTemplate = homeworkTemplate.template;
                        this.form = Object.assign({}, homeworkTemplate, {
                            chosenDaysAmount: homeworkTemplate.games[0].parameters.default.length,
                        });
                        this.$set(this.form, 'relation', {
                            chosenRelationItems: [],
                            relationItemsIds: [],
                            relationName: '',
                            visibleOnlyToMe: false,
                        });
                        if (homeworkTemplate.usersFilterType === 'schools') {
                            this.form.relation.relationName = 'school';
                            this.form.relation.chosenRelationItems = _.cloneDeep(homeworkTemplate.schools);
                        } else if (homeworkTemplate.usersFilterType === 'grade') {
                            this.form.relation.relationName = 'grade';
                            this.form.relation.chosenRelationItems = _.cloneDeep(homeworkTemplate.grades);
                        } else if (homeworkTemplate.usersFilterType === 'only_creator') {
                            this.form.relation.visibleOnlyToMe = true;
                        }
                        this.addGamesNames();
                        this.form.games.map(game => {
                            if (game.slug === 'Puzzle') {
                                this.assignImage(game);
                            }
                        });
                        this.selectedCourseType = this.coursesTypes.find(
                            access => access.mode === this.form.coursesType
                        );
                        if (this.id) {
                            const selectedGamesSlugSet = new Set(this.form.games.map(({ slug }) => slug));
                            this.oldBonusGamesSlugSet = new Set(
                                this.bonusGames
                                    .filter(({ slug }) => selectedGamesSlugSet.has(slug))
                                    .map(({ slug }) => slug)
                            );
                        }
                        this.isLoading = false;
                    });
                } else if (this.copy) {
                    this.isLoading = true;
                    this.form = Object.assign({}, this.copy, {
                        chosenDaysAmount: this.copy.games[0].parameters.default.length,
                    });
                    if (this.form.relation.relationName === 'school') {
                        this.form.relation.chosenRelationItems = _.cloneDeep(this.form.schools);
                    }
                    if (this.form.relation.relationName === 'grade') {
                        this.form.relation.chosenRelationItems = _.cloneDeep(this.form.grades);
                    }
                    if (this.form.relation.relationName === 'only_creator') {
                        this.form.relation.visibleOnlyToMe = true;
                    }
                    delete this.form.id;
                    delete this.form.userId;
                    delete this.form.updatedAt;
                    delete this.form.createdAt;
                    this.addGamesNames();
                    this.selectedCourseType = this.coursesTypes.find(access => access.mode === this.form.coursesType);
                    this.isLoading = false;
                } else {
                    if (!this.form.coursesType) {
                        this.form.coursesType = this.$route.params.coursesType || this.user.pointsAccesses[0] || '';
                    }
                    this.selectedCourseType = this.coursesTypes.find(access => access.mode === this.form.coursesType);
                }
            },
            sendForm() {
                this.$validator.validateAll().then(async isValid => {
                    if (!this.form.games.length) {
                        this.errors.add('games', this.$i18n.t('templates.template_form_noGamesError'));
                        return;
                    }
                    if (this.puzzlesAreIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_puzzle'),
                            })
                        );
                        return;
                    }
                    if (this.puzzleDatesMissMatch && this.type !== 'lesson-conducting-template') {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_puzzleGameDatesMissMatch', {
                                gameName: this.$i18n.t('common.common_gameName_puzzle'),
                            })
                        );
                        return;
                    }
                    if (this.wordsFieldIsIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_wordsField'),
                            })
                        );
                        return;
                    }
                    if (this.shutterIsIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_shutter'),
                            })
                        );
                        return;
                    }
                    if (this.anagramsAreIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_anagrams'),
                            })
                        );
                        return;
                    }
                    if (this.textsAreIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_texts'),
                            })
                        );
                        return;
                    }
                    if (this.punctuationMarksAreIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_punctuationMarks'),
                            })
                        );
                        return;
                    }
                    if (this.textsDatesMissMatch) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_textsGameDatesMissMatch', {
                                gameName: this.$i18n.t('common.common_gameName_texts'),
                            })
                        );
                        return;
                    }
                    if (this.onlyRelationTypeIsSelected) {
                        this.$toasted.error(this.$i18n.t('templates.template_form_noRelationItems'));
                        return;
                    }
                    if (this.lettersFieldIsIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_lettersField'),
                            })
                        );
                        return;
                    }
                    if (this.catchWordIsIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_catchWord'),
                            })
                        );
                        return;
                    }
                    if (this.catchWordOnlineIsIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_catchWordOnline'),
                            })
                        );
                        return;
                    }
                    if (this.textsOnlineAreIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_textsOnline'),
                            })
                        );
                        return;
                    }
                    if (this.shutterOnlineIsIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_shutterOnline'),
                            })
                        );
                        return;
                    }
                    if (this.anagramsOnlineAreIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_anagramsOnline'),
                            })
                        );
                        return;
                    }
                    if (this.classificationsIsIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_classifications'),
                            })
                        );
                        return;
                    }
                    if (this.associationsIsIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_associations'),
                            })
                        );
                        return;
                    }
                    if (this.correctiveSamplesIsIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_correctiveSamples'),
                            })
                        );
                        return;
                    }
                    if (this.fourthOneIsIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_fourthOne'),
                            })
                        );
                        return;
                    }
                    if (this.searchIsIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_search'),
                            })
                        );
                        return;
                    }
                    if (this.digitCouplesAreIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_digitCouples'),
                            })
                        );
                        return;
                    }
                    if (this.memoryIsIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_memory'),
                            })
                        );
                        return;
                    }
                    if (this.memoIsIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_memo'),
                            })
                        );
                        return;
                    }
                    if (this.vocabularyMemoIsIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_vocabularyMemo'),
                            })
                        );
                        return;
                    }
                    if (this.diadaIsIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_diada'),
                            })
                        );
                        return;
                    }
                    if (this.vocabularyWordsIsIncomplete) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_noGameParameters', {
                                gameName: this.$i18n.t('common.common_gameName_vocabularyWords'),
                            })
                        );
                        return;
                    }
                    const firstBonusWithoutAccess = await this.getFirstFormBonusGameWithoutAccess();
                    if (firstBonusWithoutAccess) {
                        this.$toasted.error(
                            this.$i18n.t('homework.homework_create_bonusCreateError', {
                                bonusGameName: this.$i18n.t(firstBonusWithoutAccess.label),
                            })
                        );
                        return;
                    }
                    if (isValid) {
                        this.isLoading = true;
                        if (this.form.relation.relationName) {
                            this.form.relation.relationItemsIds = this.form.relation.chosenRelationItems.map(
                                item => item.id
                            );
                        }
                        this.form.games.forEach((game, index) => {
                            game.position = index;
                            if (game.courseId) {
                                delete game.id;
                                delete game.courseId;
                            }
                        });
                        this.form.type = this.templateType;
                        this.sendRequest()
                            .then(() => {
                                this.isLoading = false;
                                if (this.id) {
                                    this.isSuccessfullyUpdated = true;
                                } else {
                                    this.isSuccessfullyCreated = true;
                                }
                                this.$router.push({ name: `${this.type}:list`, params: { type: this.type } });
                            })
                            .catch(err => {
                                this.isLoading = false;
                                err = err.response && err.response.data ? err.response.data : err;
                                if (err && (err.status_code === 403 || err.status_code === 404)) {
                                    this.$toasted.error(this.i18n.t(`errors.${err.message}`));
                                }
                            });
                    } else {
                        this.$toasted.info(this.$i18n.t('errors.fill_form'));
                    }
                });
            },
            async getFirstFormBonusGameWithoutAccess() {
                const selectedGamesSlugSet = new Set(this.form.games.map(({ slug }) => slug));
                const selectedBonusGames = this.bonusGames.filter(({ slug }) => selectedGamesSlugSet.has(slug));
                return selectedBonusGames.find(({ slug }) => !this.availableBonusGamesSlugSet.has(slug));
            },
            sendRequest() {
                return this.id ? TemplateApi.update(this.id, this.form) : TemplateApi.create(this.form);
            },
            editGame(index) {
                const gamesParameters = {};
                const slug = this.form.games[index].slug;
                let game = _.find(this.games, { slug });
                if (game) {
                    gamesParameters[slug] = game.parameters.default;
                    this.$store.dispatch('setHomework', this.form);
                    this.$store.dispatch('setGamesParameters', _.cloneDeep(gamesParameters));
                }

                let routeParams = {
                    id: this.id,
                    gameId: index,
                    source: this.type,
                    coursesType: this.form.coursesType,
                };
                if (game && !game.isBonusGame) {
                    this.$router.push({ name: 'game:edit', params: routeParams });
                    return;
                }
                if (this.availableBonusGamesSlugSet.has(slug)) {
                    this.$router.push({ name: 'game:edit', params: routeParams });
                    return;
                }
                if (!game) {
                    game = _.find(this.allGamesByCoursesType, { slug });
                }
                if (game) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_bonusCreateError', {
                            bonusGameName: this.$i18n.t(game.label),
                        })
                    );
                }
            },
            gameHandler(game, index) {
                this.$set(this.form.games, index, _.cloneDeep(game));
                this.form.games[index].parameters.default = _.cloneDeep(getInitParameters(this.form.games[index]));
            },
            getCourses() {
                if (this.courses.length && !this.courseTypeChanged) {
                    return;
                }
                this.loadingCourses = true;
                CourseApi.list({
                    withGames: true,
                    all: true,
                    accessType: this.selectedCourseType.mode,
                })
                    .then(data => {
                        let courses = data.courses;
                        this.courses = courses ? Object.values(courses) : [];
                        this.courses.forEach(course => {
                            course.games.forEach(game => (game.name = this.getGameName(game)));
                        });
                    })
                    .catch(() => {
                        this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                    })
                    .finally(() => {
                        this.courseTypeChanged = false;
                        this.loadingCourses = false;
                    });
            },
            addGamesNames() {
                this.form.courses.forEach(course => {
                    course.games.forEach(game => (game.name = this.getGameName(game)));
                });
                this.form.games.forEach(game => (game.name = this.getGameName(game)));
            },
            async isBonusGameHasAccess(game) {
                const params = {
                    courseType: kebabCase(this.form.coursesType),
                    gameName: game.slug,
                    schoolsIds: [this.user.school.id],
                };
                const isAccess = await BonusGamesApi.checkAccessForBonusGameForHomework(params);
                return Boolean(isAccess);
            },
            async computeAvailableBonusGamesSlugSet() {
                const set = new Set();
                const arrayAccessBonuses = await Promise.all(
                    this.bonusGames.map(game => this.isBonusGameHasAccess(game))
                );
                arrayAccessBonuses.forEach((isAccess, index) => {
                    isAccess && set.add(this.bonusGames[index].slug);
                });
                return set;
            },
            async updateAvailableBonusGamesSlugSet() {
                this.availableBonusGamesSlugSet = new Set();
                if (this.form.coursesType) {
                    this.availableBonusGamesSlugSet = await this.computeAvailableBonusGamesSlugSet();
                }
            },
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                user: state => state.auth.user,
            }),
            placeholderForMultipleDaysSelect() {
                return this.form.chosenDaysAmount ? this.form.chosenDaysAmount + '' : '1';
            },
            relationTypeName() {
                return this.form.relation.relationName === 'school' ? 'school' : 'grade';
            },
            templateType() {
                return this.$route.name.replace(/-template.*/, '');
            },
            showTextsDaysField() {
                return this.multipleDaysGameIsChosen && this.templateType !== 'lesson-conducting';
            },
            textGameHasDaysAndNoParamsArray() {
                return this.form.games.some(game => {
                    if (game.slug === 'Texts') {
                        return !_.isArray(game.parameters.default);
                    }
                });
            },
            textHasMultipleParams() {
                return this.form.chosenDaysAmount > 1;
            },
            multipleDaysGameIsChosen() {
                return this.form.games.some(game => GAMES_WITH_MULTIPLE_DATES.includes(game.slug));
            },
            multipleDaysInputLabel() {
                if (this.form.games.some(game => ['Texts', 'TextsOnline'].includes(game.slug))) {
                    return 'templates.template_form_daysForTexts';
                } else if (this.form.games.some(game => game.slug === 'Puzzle')) {
                    return 'templates.template_form_daysForPuzzle';
                } else {
                    return '';
                }
            },
            homeworkTemplateEditorHeader() {
                return this.$i18n.t(ARR_TITLE_PAGE[this.$route.name]);
            },
            games() {
                if (this.form.courses && this.form.courses.length) {
                    let games = this.form.courses[0].games;
                    games = games.filter(game => game.slug !== 'Presentations');
                    this.form.courses.forEach(course => (games = _.intersectionBy(games, course.games, 'slug')));
                    games.push(...this.availableBonusGamesWithOldBonusGames);
                    return games;
                }
                return [];
            },
            allGamesByCoursesType() {
                if (!this.form.coursesType) return [];
                const coursesTypeKebab = kebabCase(this.form.coursesType);
                return TrainerGames.games.filter(({ courseType }) => courseType === coursesTypeKebab);
            },
            bonusGames() {
                return this.allGamesByCoursesType.filter(({ isBonusGame }) => isBonusGame);
            },
            availableBonusGamesWithOldBonusGames() {
                return this.bonusGames.filter(
                    ({ slug }) => this.oldBonusGamesSlugSet.has(slug) || this.availableBonusGamesSlugSet.has(slug)
                );
            },
            shutterIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Shutter') {
                        switch (game.parameters.default.mode) {
                            case 'wordColumn':
                                return !(
                                    game.parameters.default.selectedGroups &&
                                    game.parameters.default.selectedGroups.length
                                );
                            case 'syllableColumn':
                                return !(
                                    game.parameters.default.selectedGroups &&
                                    game.parameters.default.selectedGroups.length
                                );
                            case 'text':
                                return !(
                                    game.parameters.default.sourceText && game.parameters.default.sourceText.length
                                );
                        }
                    }
                    return false;
                });
            },
            puzzlesAreIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Puzzle') {
                        if (Array.isArray(game.parameters.default)) {
                            return game.parameters.default.some(innerGame => {
                                return !(innerGame.games.length && innerGame.image);
                            });
                        }
                        return !(game.parameters.default.games.length && game.parameters.default.image);
                    }
                    return false;
                });
            },
            textsAreIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Texts') {
                        if (Array.isArray(game.parameters.default)) {
                            return game.parameters.default.some(innerGame => {
                                return !innerGame.sourceText;
                            });
                        }
                        return !game.parameters.default.sourceText;
                    }
                    return false;
                });
            },
            textsDatesMissMatch() {
                return this.form.type === 'lesson-conducting'
                    ? false
                    : this.form.games.some(game => {
                          if (game.slug === 'Texts') {
                              const amountOfTextGames = Array.isArray(game.parameters.default)
                                  ? game.parameters.default.length
                                  : 1;
                              return amountOfTextGames !== this.form.chosenDaysAmount;
                          }
                          return false;
                      });
            },
            punctuationMarksAreIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'PunctuationMarks') {
                        if (_.isArray(game.parameters.default)) {
                            return game.parameters.default.find(item => !item.sourceText);
                        }
                        return !game.parameters.default.sourceText;
                    }
                    return false;
                });
            },
            puzzleDatesMissMatch() {
                return this.form.games.some(game => {
                    if (game.slug === 'Puzzle') {
                        const amountOfPuzzleGames = Array.isArray(game.parameters.default)
                            ? game.parameters.default.length
                            : 1;
                        return amountOfPuzzleGames !== this.form.chosenDaysAmount;
                    }
                    return false;
                });
            },
            anagramsAreIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Anagrams') {
                        return !(
                            game.parameters.default.selectedGroups && game.parameters.default.selectedGroups.length
                        );
                    }
                    return false;
                });
            },
            wordsFieldIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'WordsField') {
                        return !(
                            game.parameters.default.selectedGroups && game.parameters.default.selectedGroups.length
                        );
                    }
                    return false;
                });
            },
            onlyRelationTypeIsSelected() {
                return this.form.relation.relationName && !this.form.relation.chosenRelationItems.length;
            },
            lettersFieldIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'LettersField') {
                        return !(
                            game.parameters.default.selectedLetters && game.parameters.default.selectedLetters.length
                        );
                    }
                    return false;
                });
            },
            catchWordIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'CatchWord') {
                        return !(
                            game.parameters.default.selectedGroups && game.parameters.default.selectedGroups.length
                        );
                    }
                    return false;
                });
            },
            memoryIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Memory') {
                        return !(game.parameters.default.selectedItems && game.parameters.default.selectedItems.length);
                    }
                    return false;
                });
            },
            memoIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Memo' || game.slug === 'MemoBonusGames') {
                        return !game.parameters.default.selectedItems?.length;
                    }
                    return false;
                });
            },
            diadaIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Diada') {
                        return !game.parameters.default.leftColumnExample;
                    }
                    return false;
                });
            },
            vocabularyMemoIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'VocabularyMemo') {
                        return !game.parameters.default.selectedItems?.value;
                    }
                    return false;
                });
            },
            vocabularyWordsIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'VocabularyWords') {
                        return !game.parameters.default.themes.length;
                    }
                    return false;
                });
            },
            shutterOnlineIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'ShutterOnline') {
                        switch (game.parameters.default.mode) {
                            case 'wordColumn':
                                return !(
                                    game.parameters.default.selectedGroups &&
                                    game.parameters.default.selectedGroups.length
                                );
                            case 'syllableColumn':
                                return !(
                                    game.parameters.default.selectedGroups &&
                                    game.parameters.default.selectedGroups.length
                                );
                            case 'text':
                                return !(
                                    game.parameters.default.sourceText && game.parameters.default.sourceText.length
                                );
                        }
                    }
                    return false;
                });
            },
            textsOnlineAreIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'TextsOnline') {
                        if (_.isArray(game.parameters.default)) {
                            return game.parameters.default.find(item => !item.sourceText);
                        }
                        return !game.parameters.default.sourceText;
                    }
                    return false;
                });
            },
            anagramsOnlineAreIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'AnagramsOnline') {
                        return !(
                            game.parameters.default.selectedGroups && game.parameters.default.selectedGroups.length
                        );
                    }
                    return false;
                });
            },
            catchWordOnlineIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'CatchWordOnline') {
                        return !(
                            game.parameters.default.selectedGroups && game.parameters.default.selectedGroups.length
                        );
                    }
                    return false;
                });
            },
            classificationsIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Classifications') {
                        return !(
                            game.parameters.default.selectedTopics && game.parameters.default.selectedTopics.length
                        );
                    }
                    return false;
                });
            },
            associationsIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Associations') {
                        return !(
                            game.parameters.default.selectedSubTopics &&
                            game.parameters.default.selectedSubTopics.length
                        );
                    }
                    return false;
                });
            },
            correctiveSamplesIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'CorrectiveSamples' || game.slug === 'CorrectiveSamplesWithTime') {
                        return !(game.parameters.default.selectedTheme && game.parameters.default.selectedTheme.theme);
                    }
                    return false;
                });
            },
            fourthOneIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'FourthOne') {
                        return !(
                            game.parameters.default.themes &&
                            game.parameters.default.themes.length &&
                            game.parameters.default.themes.every(theme => theme.first && theme.second)
                        );
                    }
                    return false;
                });
            },
            searchIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Search') {
                        return !(
                            game.parameters.default.searchTopic &&
                            game.parameters.default.selectedTopics &&
                            game.parameters.default.selectedTopics.length
                        );
                    }
                    return false;
                });
            },
            digitCouplesAreIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'DigitCouples') {
                        return !(game.parameters.default.difficulties && game.parameters.default.difficulties.length);
                    }
                    return false;
                });
            },
        },
        components: {
            HelpText,
            CsCheckbox,
            GamesList,
        },
    };
</script>

<style lang="scss" scoped>
    .row {
        margin: 0;
    }
    .list {
        margin: 0;
        padding: 0;
        height: 100%;
        background-color: $x-color-white;
        box-sizing: border-box;
        @include media($sm) {
            padding: 30px;
            border-radius: $border-radius-20;
        }
        @media screen and (max-width: 568px) {
            border-radius: 0;
        }
        font-weight: normal;
    }
    .list__content {
        margin: 0;
        padding: 15px;
        height: 100%;
        background-color: $hsl-color-gray-98;
        box-sizing: border-box;
        border-radius: $border-radius-20;
    }
    .form-container {
        &__header {
            margin-bottom: 25px;
            text-align: center;
        }
        &__fields {
            max-width: 640px;
            margin: 0 auto 40px auto;
            @media screen and (max-width: 575px) {
                margin: 0 auto 30px auto;
            }
        }
        &__label {
            margin-right: 20px;
            width: 20%;
            text-align: right;
            @media screen and (max-width: 575px) {
                margin: 0 0 20px 0;
                width: 100%;
                max-width: 380px;
                text-align: left;
            }
        }
        &__title {
            font-size: 24px;
            line-height: 30px;
            font-weight: 500;
        }
        &__column {
            width: 100%;
            position: relative;
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            @media screen and (max-width: 575px) {
                flex-direction: column;
                margin-bottom: 30px;
            }
        }
        &__select {
            width: 100%;
            max-width: 380px;
        }
    }
    .form-container-footer {
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 640px;
        margin: 0 auto;
        @media screen and (max-width: 575px) {
            flex-direction: column;
        }
        &__button {
            @media screen and (max-width: 575px) {
                display: block;
                width: 176px;
            }
            &_submit {
                min-width: 134px;
                margin-left: 20px;
                @media screen and (max-width: 575px) {
                    margin-left: 0;
                    margin-top: 20px;
                }
            }
        }
    }
    .info-text {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        color: #828282;
    }
    .delete-icon {
        margin-left: 10px;
        color: $hsl-color-green-48;
        &:hover {
            color: $hsl-color-red-62;
        }
        @media screen and (max-width: 575px) {
            position: absolute;
            top: 50%;
            right: 30%;
        }
        @media screen and (max-width: 470px) {
            right: 25%;
        }
        @media screen and (max-width: 410px) {
            right: 0;
        }
    }
    .games-fields {
        margin: 0 auto;
    }
</style>
